import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { mainCta } from '@/mocks/cta';

interface FinalCTAProps {
  currentLang: string;
}

export default function FinalCTA({ currentLang }: FinalCTAProps) {
  const { t } = useTranslation('home');

  return (
    <section className="py-16 md:py-24 bg-foreground-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20silk%20fabric%20in%20soft%20coral%20peach%20and%20cream%20tones%20elegant%20artistic%20background%20texture%20warm%20gradient%20luxury%20minimal%20aesthetic%20high%20detail%20smooth%20surface&width=1600&height=600&seq=cta-bg-001&orientation=landscape&nocache=true"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-10 xl:px-16 max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-semibold text-background-50 mb-4">
          {t('final_cta_h2')}
        </h2>
        <p className="text-background-50/70 text-base md:text-lg leading-relaxed mb-8 md:mb-10">
          {t('final_cta_copy')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to={`/${currentLang}/allchinabuy-spreadsheet/`}
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 font-label font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            {t('final_cta_primary')}
            <i className="ri-arrow-right-line"></i>
          </Link>
          <a
            href={mainCta.mainSite}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 border border-background-50/30 text-background-50 font-label font-semibold text-sm rounded-md hover:bg-background-50/10 transition-colors whitespace-nowrap"
          >
            <i className="ri-external-link-line"></i>
            {t('final_cta_secondary')}
          </a>
        </div>
      </div>
    </section>
  );
}